import { getLanguage, getTranslation } from './translationService';

// Référence pour stocker les fonctions de mise à jour
let updateListeners = [];

/**
 * S'abonner aux changements de langue
 * @param {Function} callback - Fonction à appeler lors d'un changement de langue
 * @returns {Function} - Fonction pour se désabonner
 */
export const subscribeToLanguageChanges = (callback) => {
  updateListeners.push(callback);
  return () => {
    updateListeners = updateListeners.filter(
      (listener) => listener !== callback
    );
  };
};

// Écoutez l'événement de changement de langue global
if (typeof window !== 'undefined') {
  window.addEventListener('languageChange', () => {
    // Notifiez tous les abonnés du changement
    updateListeners.forEach((listener) => listener());
  });
}

/**
 * Récupère la traduction depuis le service avec gestion d'erreur
 * @param {string} cle_traduction - Clé de traduction à rechercher
 * @returns {string|function} - Traduction dans la langue actuelle ou la clé si non trouvée
 * @private
 */
const _getTranslationSafe = (cle_traduction) => {
  const currentLanguage = getLanguage();

  try {
    return getTranslation(cle_traduction, currentLanguage);
  } catch (error) {
    console.warn(
      '/!\\',
      cle_traduction,
      " n'existe pas dans le dictionnaire de langues. /!\\"
    );
    return cle_traduction;
  }
};

/**
 * Fonction qui retourne la traduction d'un mot simple selon la langue actuelle
 * @param {string} cle_traduction - Clé de traduction à rechercher
 * @returns {string} - Traduction dans la langue actuelle ou la clé si non trouvée
 */
export const checkMot = (cle_traduction) => {
  const translation = _getTranslationSafe(cle_traduction);

  // Si la traduction est une fonction (ce qui ne devrait pas arriver pour des mots simples),
  // on la retourne sans paramètres
  if (typeof translation === 'function') {
    return translation();
  }

  return translation;
};

/**
 * Fonction qui retourne la traduction d'une phrase selon la langue actuelle
 * @param {string} cle_traduction - Clé de traduction à rechercher
 * @param {string} str - Paramètres optionnels pour les phrases dynamiques
 * @returns {string} - Traduction dans la langue actuelle ou la clé si non trouvée
 */
export const checkPhrase = (cle_traduction, str) => {
  const translation = _getTranslationSafe(cle_traduction);

  // Si la traduction est une fonction, lui passer le paramètre str
  if (typeof translation === 'function') {
    return translation(str);
  }

  // Sinon, retourner directement la traduction (chaîne de caractères)
  return translation;
};
